var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { TableEvent } from "./Table.events";
import { utils } from "zebulon-controls";
import { filtersFunction, getSorts, sortsFunction } from "./utils/filters.sorts";

export var TableFilterSort = function (_TableEvent) {
  _inherits(TableFilterSort, _TableEvent);

  function TableFilterSort() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableFilterSort);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableFilterSort.__proto__ || Object.getPrototypeOf(TableFilterSort)).call.apply(_ref, [this].concat(args))), _this), _this.adjustScrollRows = function (filteredData) {
      if (_this.state) {
        var _this$state = _this.state,
            selectedRange = _this$state.selectedRange,
            scroll = _this$state.scroll,
            meta = _this$state.meta;
        // let { rows, columns } = scroll;

        if (!filteredData.length) {
          selectedRange.end = {};
          selectedRange.start = {};
          _this.hasFocus = false;
          _this.bLoaded = undefined;
        } else if (selectedRange.end.rows === undefined) {
          var columns = (meta.visibleIndexes || [0])[0];
          selectedRange.end = { rows: 0, columns: columns };
          selectedRange.start = { rows: 0, columns: columns };
          _this.bLoaded = true;
          _this.scrollTo(selectedRange.end.rows, 1, selectedRange.end.columns, scroll.columns.direction, false, filteredData.length);
        } else if (selectedRange.end.rows > filteredData.length - 1) {
          selectedRange.end.rows = filteredData.length - 1;
          _this.scrollTo(selectedRange.end.rows, 1, selectedRange.end.columns, scroll.columns.direction, false, filteredData.length);
        } else {
          _this.scrollTo(selectedRange.end.rows, scroll.rows.direction, selectedRange.end.columns, scroll.columns.direction, false, filteredData.length);
        }
        // if (
        //   // filteredData.length !== this.getFilteredDataLength() &&
        //   rows.startIndex !== 0 &&
        //   rows.index +
        //     (rows.direction === 1 ? this.rowsHeight / this.rowHeight : 0) >
        //     filteredData.length
        // ) {
        //   rows = {
        //     index: 0,
        //     direction: 1,
        //     startIndex: 0,
        //     shift: 0,
        //     position: 0
        //   };
        //   this.setState({ scroll: { rows, columns } });
        // }
        return filteredData[selectedRange.end.rows];
      }
    }, _this.filters = function (data, filters, noFocus, updatedRows) {
      if (!Array.isArray(data)) {
        return [];
      }
      var filter = filtersFunction(filters, _this.props.params, data, updatedRows, _this.props.utils);
      var filteredData = data.filter(filter);
      if (_this.props.onFilter) {
        _this.props.onFilter({
          filters: filters,
          filteredData: filteredData,
          data: data,
          params: _this.props.params,
          updatedRows: updatedRows
        });
      }
      return filteredData;
    }, _this.getFilterItems = function (filter, column) {
      var _this$state2 = _this.state,
          meta = _this$state2.meta,
          data = _this$state2.data,
          updatedRows = _this$state2.updatedRows;

      if (!meta.serverPagination) {
        if (!filter || !filter.items) {
          var items = {};
          _this.props.data.forEach(function (row) {
            var id = (column.accessorFunction || function (_ref2) {
              var row = _ref2.row;
              return row[column.id];
            })({
              row: row,
              column: column,
              status: updatedRows[row.index_],
              params: _this.props.params,
              data: data
            }); // a voir status
            var label = column.selectItems && !column.reference && !Array.isArray(column.selectItems) && _typeof(column.selectItems) === "object" ? (column.selectItems[id] || {}).caption : id;
            items[id] = {
              id: id,
              label: (column.formatFunction || function (_ref3) {
                var value = _ref3.value;
                return utils.formatValue(value, null, column.decimals);
              })({
                value: label,
                column: column,
                row: row,
                params: _this.props.params,
                status: updatedRows[row.index_],
                data: data
              }) || id
            };
          });
          column.items = Object.values(items);
          column.items.sort(function (itemA, itemB) {
            return utils.isNullValue(itemA.label) ? -1 : (itemA.label > itemB.label) - (itemA.label < itemB.label);
          });
          filter = column;
        }
      } else {
        column.items = [];
        filter = column;
        // ????
      }
      return filter;
    }, _this.openFilter = function (e, column) {
      if (_this.isOpening) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.persist();
      var filter = _this.state.filters[column.id];
      filter = _this.getFilterItems(filter, column);
      filter.top = _this.rowHeight + (_this.state.meta.table.caption ? 30 : 0); // e.target.offsetParent.offsetTop; //this.nFilterRows * this.rowHeight;
      filter.left = e.target.offsetLeft;
      var ok = _this.canQuit("rowQuit", function (ok) {
        if (ok) {
          return _this.openFilter_(e, column, filter);
        }
      });
      if (ok) {
        return _this.openFilter_(e, column, filter);
      }
    }, _this.openFilter_ = function (e, column, filter) {
      if (column.filterType !== "values") {
        e.target.focus();
        _this.hasFocus = false;
        return _this.closeOpenedWindows();
      }
      // column.position + this.rowHeight - this.state.scroll.columns.position;
      // console.log("filtersort", this.hasFocus);
      _this.hasFocus = false;
      _this.setState({
        openedFilter: column.id,
        filters: Object.assign({}, _this.state.filters, _defineProperty({}, column.id, filter))
      });
    }, _this.onChangeFilter = function (e, row, column, filterTo) {
      var ok = _this.props.onTableChange("filter", function (ok) {
        if (ok) {
          _this.onChangeFilter_(e, row, column, filterTo);
        }
      });
      if (ok) {
        _this.onChangeFilter_(e, row, column, filterTo);
      }
    }, _this.onChangeFilter_ = function (e, row, column, filterTo) {
      var _this$state3 = _this.state,
          selectedRange = _this$state3.selectedRange,
          filters = _this$state3.filters,
          meta = _this$state3.meta,
          data = _this$state3.data,
          updatedRows = _this$state3.updatedRows;
      // const ok = this.selectRange(selectedRange, undefined, this.row, "quit");
      // return false;

      _this.closeOpenedWindows();
      var v = e;
      if (v === undefined) {
        return;
      }
      if (v !== column.v && !filterTo || v !== column.vTo && filterTo) {
        _this.hasFocus = false;
        if (column.filterType === "between" && filterTo) {
          column.vTo = v;
        } else {
          column.v = v;
        }
        filters[column.id] = column;
        _this.changingFilter = true;
        var filteredData = _this.filters(data, filters, true, updatedRows);
        // if (!meta.serverPagination) {
        _this.sorts(filteredData, meta.properties);
        _this.setState({ filteredData: filteredData });
        _this.selectRange(selectedRange, undefined, _this.adjustScrollRows(filteredData), "enter", true);
        // }
      }
    }, _this.onChangeFilterValues = function (filter) {
      var openedFilter = _this.state.openedFilter;
      _this.setState({ openedFilter: undefined });
      var ok = _this.props.onTableChange("filter", function (ok) {
        if (ok) {
          _this.onChangeFilterValues_(openedFilter, filter);
        }
      });
      if (ok) {
        _this.onChangeFilterValues_(openedFilter, filter);
      }
    }, _this.onChangeFilterValues_ = function (openedFilter, filter) {
      var _this$state4 = _this.state,
          filters = _this$state4.filters,
          meta = _this$state4.meta,
          data = _this$state4.data;

      var column = filters[openedFilter];
      column.v = filter;
      filters[column.id] = column;
      var filteredData = _this.filters(data, filters);
      // if (!meta.serverPagination) {
      _this.sorts(filteredData, meta.properties);
      _this.setState({ filteredData: filteredData });
      _this.selectRange(_this.range, undefined, _this.adjustScrollRows(filteredData), "enter");
      // }
    }, _this.sorts = function (data, columns) {
      var sorts = getSorts(columns);
      if (!Array.isArray(data)) {
        if (_this.state && _this.state.meta.serverPagination) {
          return _this.pagination({
            sorts: sorts,
            callbackAfter: function callbackAfter() {
              _this.selectRange_(_this.range, undefined, undefined, "enter");
            }
          });
        }
        return [];
      }
      if (sorts.length) {
        data.sort(sortsFunction(sorts));
      }
      if (_this.props.onSort) {
        _this.props.onSort({
          sorts: columns,
          filteredData: data,
          data: _this.props.data,
          params: _this.props.params
        });
      }
    }, _this.onSort = function (column, doubleClick) {
      if (!_this.state.meta.table.noOrder) {
        var ok = _this.props.onTableChange("sort", function (ok) {
          if (ok) {
            _this.onSort_(column, doubleClick);
          }
        });
        if (ok) {
          _this.onSort_(column, doubleClick);
        }
      }
    }, _this.onSort_ = function (column, doubleClick) {
      var _this$state5 = _this.state,
          filteredData = _this$state5.filteredData,
          meta = _this$state5.meta;

      _this.closeOpenedWindows();
      if (_this.selectRange(_this.range, undefined, _this.row, "quit") === false) {
        return false;
      }
      var columns = meta.properties;
      var sorts = [];
      columns.forEach(function (col) {
        if (doubleClick && col.id !== column.id) {
          col.sort = undefined;
          col.sortOrder = undefined;
        }
        if (col.id === column.id) {
          if (col.sort === undefined) {
            col.sort = "asc";
          } else if (col.sort === "asc") {
            col.sort = "desc";
          } else if (col.sort === "desc") {
            col.sort = undefined;
            col.sortOrder = undefined;
          }
        }
        if (col.sort !== undefined) {
          sorts.push({
            index: col.index_,
            sortOrder: col.sortOrder === undefined ? 1000 : col.sortOrder
          });
        }
      });
      sorts.sort(function (a, b) {
        return (a.sortOrder > b.sortOrder) - (b.sortOrder > a.sortOrder);
      });
      sorts.forEach(function (col, index) {
        return columns[col.index].sortOrder = index;
      });
      _this.sorts(filteredData, columns);
      if (!meta.serverPagination) {
        _this.selectRange(_this.range, undefined, undefined, "enter");
        _this.setState({ filteredData: filteredData });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // ----------------------------------------
  // filtering
  // ----------------------------------------

  // a voir si pagination server ???
  //

  // ----------------------------------------
  //sorting
  // ----------------------------------------


  return TableFilterSort;
}(TableEvent);
// const dataStrings = computeRowSearch(this.state.data, this.state.meta, {});
//    const indexes = rowSearch(dataStrings, "22/02");


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/Table.filters.sorts.js
// module id = 344
// module chunks = 0